import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";


export class CreateMagiisAccessUserProfileCarrierProfileId extends IRequestCommand<
  ICreateMagiisAccessUserProfileCarrierProfileIdResponse,
  ErrorDetails,
  ICreateMagiisAccessUserProfileCarrierProfileIdParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.POST;

  override setParameters(parameters: ICreateMagiisAccessUserProfileCarrierProfileIdParameters) {
    this._commandBody = parameters.userProfileIds.map((id)=>Number(id)) as any;
    this.urlSections.push('magiisaccess');
    this.urlSections.push(`userprofile`);
    this.urlSections.push(`carrierprofileid`);
    this.urlSections.push(`${parameters.carrierProfileId}`);
    this.composeUrl();
  }
}

export interface ICreateMagiisAccessUserProfileCarrierProfileIdParameters extends ICommandParameters{
  carrierProfileId: number;
  userProfileIds: (string|number)[];
}

export interface ICreateMagiisAccessUserProfileCarrierProfileIdResponse extends ICommandResponse{

}
